import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { recordRouteBreadcrumb } from '@/lib/frontendDiagnostics';

export const RouteDiagnostics = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    recordRouteBreadcrumb(path, previousPath.current ? navigationType : 'initial');
    previousPath.current = path;
  }, [location.pathname, location.search, navigationType]);

  return null;
};
